
import AbstractInstaller from "../../core/application/AbstractInstaller";
import ConversationReflectionEndedEvent from "../conversation-reflection/event/ConversationReflectionEndedEvent";
import ConversationEndedEvent from "../conversation/event/ConversationEndedEvent";
import PlatformUserTrackingService from "./controller/PlatformUserTrackingService";
import TrackPlatformConversationEnded from "./controller/TrackPlatformConversationEnded";
import TrackPlatformReflectionEnded from "./controller/TrackPlatformReflectionEnded";
import PlatformUserModel from "./model/PlatformUserModel";
import AuthenticatePlatformTask from "./task/AuthenticatePlatformTask";
import InitializePlatformTask from "./task/InitializePlatformTask";

export default class PlatformInstaller extends AbstractInstaller {
    /**
     * @constructor
     * @param {infuse.Injector} injector 
     * @param {soma.Commands} commands 
     * @param {MediatorMapping} mediatorMap 
     */
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        commands.add(ConversationEndedEvent.TYPE, TrackPlatformConversationEnded);
        commands.add(ConversationReflectionEndedEvent.PERFORM, TrackPlatformReflectionEnded);

        injector.mapClass("platformUserTrackingService", PlatformUserTrackingService, true);
        injector.mapClass("platformUserModel", PlatformUserModel, true);

        this._addStartupTask(InitializePlatformTask, "initializePlatformTask", 1);
        this._addStartupTask(AuthenticatePlatformTask, "authenticatePlatformTask", 1, ["initializePlatformTask"]);
    }
}